module.exports = __webpack_public_path__ + "img/sonos.7e952659.png";